// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1656":"cd911b53d3f4d200","7412":"21e47d72ad49b375"}[chunkId] + ".js";
};